// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".settings__actions--save[data-v-2c283742]{margin-top:30px;height:44px}", ""]);
// Exports
module.exports = exports;
